export type UserPlanFeatureType = "boolean" | "number" | "string";

type UserPlanFeatureBase = {
  title: string;
  caption?: string;
  unit?: string;
};

export type AccountPlanFeature =
  | (UserPlanFeatureBase & {
      type: "boolean";
      value?: boolean;
    })
  | (UserPlanFeatureBase & {
      type: "number";
      value: number;
      unlimited: boolean;
    })
  | (UserPlanFeatureBase & {
      type: "string";
      value: string;
    });

export type AccountPlanFeatures = Record<string, AccountPlanFeature>;
export type AccountPlanType = "FREE" | "PERSONAL" | "ORGANIZATION";

export type AccountPlanAddon = {
  title: string;
  description?: string;
  order: number;
  featureKey: string;
  value: number;
  unit: string;
  priceMonthly: number;
  priceYearly?: number | null;
  currency: string;
};

export type AccountPlanAddons = AccountPlanAddon[];

export type AccountPlanModel = {
  id?: string;
  name: string;
  planType: AccountPlanType;
  order: number;
  priceMonthly: number;
  priceYearly: number;
  currency: string;
  description: string;
  features: AccountPlanFeatures;
  availableAddons: AccountPlanAddons;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
};

export enum AccountSubscriptionStatus {
  ACTIVE = "ACTIVE",
  PENDING_CHECKOUT = "PENDING_CHECKOUT",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  SUSPENDED = "SUSPENDED",
  CANCEL_AT_PERIOD_END = "CANCEL_AT_PERIOD_END",
  CANCELED = "CANCELED",
}

export const ACCOUNT_SUBSCRIPTION_STATUS = Object.values(
  AccountSubscriptionStatus,
);

export type AccountPlanSnapshotProps = {
  id: string;
  name: string;
  planType: AccountPlanType;
  order: number;
  priceMonthly: number;
  priceYearly: number;
  currency: string;
  description: string;
  features: AccountPlanFeatures;
};

export type AccountSubscriptionModel = {
  id?: string;
  planId: string; // referência atual
  cycle?: "MONTHLY" | "YEARLY";
  status: AccountSubscriptionStatus;
  startedAt?: Date;
  expiresAt?: Date | null;
  planSnapshot: AccountPlanSnapshotProps;
  availableAddons?: string[];
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
};
